import { ElementRef, SecurityContext } from '@angular/core'
import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { LandingPagesService } from '../../landing-pages.service'
import { CommonService } from '../../../../shared/services/common.service'
import { environment } from '../../../../../environments/environment'

@Component({
  standalone: false,

  selector: 'vs-quick-tracking-widget',
  templateUrl: './quick-tracking-widget.component.html',
  styleUrls: ['./quick-tracking-widget.component.scss'],
})
export class QuickTrackingWidgetComponent implements OnInit {
  orderCheckoutForm: FormGroup
  isSubmitted: boolean = false
  firstMandateFieldError: boolean = false
  secondMandateFieldError: boolean = false
  bannerText1: string = ''
  bannerText2: string = ''
  bannerText3: string = ''
  showBannerTop: boolean = false
  dataObj: any

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public commonService: CommonService,
    private landingPagesService: LandingPagesService,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.fetchBannerWordings()
    this.createForm()
  }

  createForm() {
    this.orderCheckoutForm = this.formBuilder.group({
      customerNumber: new FormControl(null, [Validators.required]),
      purchaseOrderNo: new FormControl(
        null,
        Validators.pattern('^[a-zA-Z0-9- ]+$')
      ),
      referenceNumber: new FormControl(null),
    })

    this.orderCheckoutForm.controls['customerNumber'].valueChanges.subscribe(
      (data) => {
        if (data !== undefined && data !== null && data.trim().length > 0) {
          this.checkValidationCustomerNumber()
        }
      }
    )
    this.orderCheckoutForm.controls['purchaseOrderNo'].valueChanges.subscribe(
      (data) => {
        if (data !== undefined && data !== null && data.trim().length > 0) {
          this.checkValidationPORefNumber()
        }
      }
    )
    this.orderCheckoutForm.controls['referenceNumber'].valueChanges.subscribe(
      (data) => {
        if (data !== undefined && data !== null && data.trim().length > 0) {
          this.checkValidationPORefNumber()
        }
      }
    )
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
  get form() {
    return this.orderCheckoutForm.controls
  }

  checkValidationCustomerNumber() {
    if (
      this.orderCheckoutForm.get('customerNumber').value !== null &&
      this.orderCheckoutForm.get('customerNumber').value.trim().length > 0
    ) {
      this.firstMandateFieldError = false
    } else {
      this.firstMandateFieldError = true
    }
  }
  checkValidationPORefNumber() {
    if (
      (this.orderCheckoutForm.get('purchaseOrderNo').value !== null &&
        this.orderCheckoutForm.get('purchaseOrderNo').value.trim().length >
          0) ||
      (this.orderCheckoutForm.get('referenceNumber').value !== null &&
        this.orderCheckoutForm.get('referenceNumber').value.trim().length > 0)
    ) {
      this.secondMandateFieldError = false
    } else {
      this.secondMandateFieldError = true
    }
  }

  submitTrackStatus() {
    this.isSubmitted = true
    this.checkValidationCustomerNumber()
    this.checkValidationPORefNumber()
    if (
      !this.firstMandateFieldError &&
      !this.secondMandateFieldError &&
      this.orderCheckoutForm.valid
    ) {
      this.takeUserToMyOrder()
    }
  }

  ngAfterViewChecked() {
    let bannerElement = this.elRef.nativeElement.querySelectorAll('.banner')[0]
    if (bannerElement !== undefined) {
      const banner_url = environment.occBaseUrl + this.dataObj['media'].url
      this.domSanitizer.sanitize(SecurityContext.URL, banner_url)
      this.renderer.setStyle(
        this.domSanitizer.sanitize(SecurityContext.NONE, bannerElement),
        'background-image',
        `url(${banner_url})`
      )
    }
  }

  fetchBannerWordings() {
    this.landingPagesService.fetchTopBanner().subscribe(
      (data) => {
        if (data !== null && data !== undefined) {
          this.bannerText1 = data['headline']
          this.bannerText2 = data['title']
          this.bannerText3 = data['content']
          this.showBannerTop = data['visible']
          this.dataObj = data
        }
      },
      (err) => {
        let bannerElement =
          this.elRef.nativeElement.querySelectorAll('.banner')[0]
        const banner_url = this.domSanitizer.sanitize(
          SecurityContext.URL,
          '../../../../../assets/img/VS_Banner.png'
        )
        this.renderer.setStyle(
          this.domSanitizer.sanitize(SecurityContext.NONE, bannerElement),
          'background-image',
          `url(${banner_url})`
        )
      }
    )
  }

  takeUserToMyOrder() {
    this.landingPagesService.floatOrderTrackingValues.next({
      customerNumber: this.orderCheckoutForm.get('customerNumber').value,
      purchaseOrderNumber: this.orderCheckoutForm.get('purchaseOrderNo').value,
      orderReferenceNumber: this.orderCheckoutForm.get('referenceNumber').value,
    })
    this.router.navigate(['/order-status'])
  }
}
